import { FC } from 'react';
import { ModalManager } from 'context/ModalRouter';
import Modal from 'components/shared/Modal';
import { ListPost } from 'types/PostDetail';
import MovePostsToTrashPreselectedPosts from './MovePostsToTrashPreselectedPosts';
import MovePostsToTrashWithPostsSelection from './MovePostsToTrashWithPostsSelection';

type Props = {
  modalManager: ModalManager;
  initialPosts: ListPost[];
};

const MovePostsToTrashModal: FC<Props> = ({ modalManager, initialPosts }) => {
  return (
    <Modal size="md" modalManager={modalManager}>
      {initialPosts.length > 0 ? (
        <MovePostsToTrashPreselectedPosts
          initialPosts={initialPosts}
          onFinish={modalManager.close}
        />
      ) : (
        <MovePostsToTrashWithPostsSelection onFinish={modalManager.close} />
      )}
    </Modal>
  );
};

export default MovePostsToTrashModal;
